export default {"src":"/_next/static/media/footer-apex-logo.eb0a2bbd.svg","height":65,"width":267,"blurWidth":0,"blurHeight":0};